import axios from 'axios'
import store from '../../store/index'

const state = {
  printers: {},
}

const mutations = {
  printers_data (state, printers) {
    state.printers = printers
  },
}

const actions = {
  printersAuthentication ({ commit }, authentication) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/printers/auth',
        data: authentication,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createPrinter ({ commit }, printerPayload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/printers/new?locationId=' + printerPayload.locationId,
        method: 'POST',
        data: printerPayload.message,
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deletePrinter ({ commit }, printerId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/printers?printerId=' + printerId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPrinters ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/printers/list?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  checkAuth ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/printers/auth/check',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
